import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'

export const PageContainer = styled.div`
  background: ${Colors.Neutral10};
  display: flex;
  justify-content: center;
  min-height: 100vh;
`
